import {
  Button,
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@jobcost-monorepo/ui';
import { capitalizeFirstLetter } from '@jobcost-monorepo/utils';
import dayjs from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  modalDate: Date | null;
  handleCloseModal: () => void;
  handleConfirmDate: () => void;
}

const HolidayModal: React.FC<Props> = ({
  modalDate,
  handleCloseModal,
  handleConfirmDate,
}) => {
  const { t } = useTranslation('timesheets');

  return (
    <Dialog open={!!modalDate} onOpenChange={handleCloseModal}>
      <DialogTrigger asChild className="w-full"></DialogTrigger>
      <DialogContent className="relative z-50 transform overflow-y-auto overflow-auto scroll-auto rounded-lg mx-5 border border-gray dark:border-lightGray bg-white dark:bg-dark px-4 pt-5 pb-4 text-left shadow-xl transition-all w-full">
        <div>
          <h3 className="text-lg leading-6 font-medium text-gray-900 dark:text-white">
            {t('holidayModal.title')}
          </h3>
          <div className="mt-2">
            <p className="text-sm text-gray-500 dark:text-gray-300">
              {t('holidayModal.message', {
                selectedDate: capitalizeFirstLetter(
                  dayjs(modalDate).format('dddd D MMMM YYYY'),
                ),
              })}
            </p>
          </div>
          <div className="mt-4 flex flex-row-reverse">
            <Button onClick={handleConfirmDate} className="ml-3">
              {t('holidayModal.confirm')}
            </Button>
            <Button variant="subtle" onClick={handleCloseModal}>
              {t('holidayModal.cancel')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default HolidayModal;
